import joi from 'joi';
import {
  $channelInfo,
  CampaignAccessRewardData,
  CampaignCodeRewardData,
  RewardAttributes,
  RewardPeriod,
  RewardType,
} from './rewards.types';
import { $rewardI18nAttribute, $rewardsI18nextAttributes } from './rewards-i18next-attributes';
import { AddRewardBody, UpdateRewardBody } from './rewards-api-client';
import { localizedPropertySchema, naturalNumberSchema } from '../utils';

export function rewardSchemaForLanguages(languages: string[], isCreating: boolean) {
  return joi.object<RewardAttributes>({
    type: $rewardType.required(),
    i18nAttributes: joi.object(
      languages.reduce((attributes, language) => {
        return {
          ...attributes,
          [language]: $rewardI18nAttribute,
        };
      }, {}),
    ),
    ...(!isCreating
      ? {
          data: joi.when('type', {
            switch: [
              {
                is: RewardType.CAMPAIGN_ACCESS,
                then: campaignAccessRewardData$.required(),
              },
              {
                is: RewardType.CAMPAIGN_CODE,
                then: campaignCodeData$.required(),
              },
            ],
            otherwise: joi.forbidden(),
          }),
        }
      : {}),
  });
}

export const $rewardType = joi.string().valid(...Object.values(RewardType));

export const campaignAccessRewardData$ = joi.object<CampaignAccessRewardData>({
  channelInfoByLanguage: localizedPropertySchema($channelInfo).required(),
  accessData: joi.object<CampaignAccessRewardData['accessData']>({
    nbParticipations: naturalNumberSchema.required(),
    validityPeriod: joi.object<CampaignAccessRewardData['accessData']['validityPeriod']>({
      unit: joi
        .string()
        .valid(...Object.values(RewardPeriod))
        .required(),
      value: naturalNumberSchema.required(),
    }),
  }),
});

export const campaignCodeData$ = joi.object<CampaignCodeRewardData>({
  campaignCodeData: joi.object({
    codeListId: joi.string().required(),
  }),
});

export const $rewardData = joi.when('$type', {
  // $type is taken from context
  switch: [
    {
      is: RewardType.CAMPAIGN_ACCESS,
      then: campaignAccessRewardData$.required(),
    },
    {
      is: RewardType.CAMPAIGN_CODE,
      then: campaignCodeData$.required(),
    },
  ],
  otherwise: joi.forbidden(),
});

export const addRewardBody$ = joi.object<AddRewardBody>({
  type: $rewardType.required(),
  i18nAttributes: $rewardsI18nextAttributes,
});

export const updateRewardBody$ = joi.object<UpdateRewardBody>({
  i18nAttributes: $rewardsI18nextAttributes,
  data: $rewardData,
  clientIds: joi.array().items(joi.number()).optional().allow(null), //deprecated
});
